export const setFontSize = fontSize => ({
  type: 'SET_FONT_SIZE',
  payload: fontSize,
});
